export default function deleteIndexedDbDatabase(name: string): Promise<unknown> {
  return new Promise((resolve, reject) => {
    const request = window.indexedDB.deleteDatabase(name);
    request.onerror = reject;
    request.onsuccess = resolve;
  });
}
